// extracted by mini-css-extract-plugin
export default {"Page":"AboutPage_Page__C1x9O","Banner":"AboutPage_Banner__S+l9D","PageTitle":"AboutPage_PageTitle__e1M2Q"};